import { Routes } from '@angular/router';

import { authGuard } from './shared/guards/auth.guard';
import { LoginComponent } from './account/login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ActivityComponent } from './activity/activity.component';
import { MessagesComponent, messagesResolver } from './messages/messages.component';
import { NewsComponent, newsResolver } from './news/news.component';
import { PrivacyComponent } from './shared/privacy/privacy.component';
import { TermsComponent } from './shared/terms/terms.component';
import { SignupPricingComponent } from './pricing/signup-pricing/signup-pricing.component';
import { SignupComponent } from './signup/signup.component';
import { SignupThankYouComponent } from './signup/signup-thank-you/signup-thank-you.component';
import { UpgradePricingComponent } from './pricing/upgrade-pricing/upgrade-pricing.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { UpgradeThankYouComponent } from './upgrade/upgrade-thank-you/upgrade-thank-you.component';
import { HiddenLoginComponent } from './account/login/hidden-login/hidden-login.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login/:id', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'hidden-login', component: HiddenLoginComponent },
  { path: 'pricing', component: SignupPricingComponent },
  { path: 'signup/thankyou', component: SignupThankYouComponent },
  { path: 'signup/:id', component: SignupComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'upgrade-pricing', component: UpgradePricingComponent, canActivate: [authGuard] },
  { path: 'upgrade/thankyou', component: UpgradeThankYouComponent },
  { path: 'upgrade', component: UpgradeComponent, canActivate: [authGuard] },
  { path: 'account', loadChildren: () => import('./account/account.routes').then(m => m.ACCOUNT_ROUTES) },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  { path: 'activity', component: ActivityComponent, canActivate: [authGuard] },
  { path: 'messages', component: MessagesComponent, canActivate: [authGuard], resolve: { messages: messagesResolver } },
  { path: 'news', component: NewsComponent, canActivate: [authGuard], resolve: { news: newsResolver } },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'terms', component: TermsComponent }
];
